/**
 * BattleCreateRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * BattleCreateRes
 */
export interface BattleCreateRes {
  /** 对战ID */
  id?: string
}

/**
 * BattleCreateRes Schema
 */
export const BattleCreateResSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '对战ID',
      format: 'string',
      type: 'string',
      label: '对战ID',
    },
  },
  type: 'object',
}
